import { render, staticRenderFns } from "./Assigment.vue?vue&type=template&id=79f16062&scoped=true"
import script from "./Assigment.vue?vue&type=script&lang=js"
export * from "./Assigment.vue?vue&type=script&lang=js"
import style0 from "./Assigment.vue?vue&type=style&index=0&id=79f16062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f16062",
  null
  
)

export default component.exports